import { Abi } from 'viem'

/**
 * Assemble Protocol Contract ABI
 * 
 * Generated from the Assemble.sol contract
 */
export const ASSEMBLE_ABI: Abi = require('./abi.json')

export default ASSEMBLE_ABI 